import { eEscrowWireDisbursementCategories } from './enums/eEscrowWireDisbursementCategories';

export const EscrowWireDisbursementCategoriesOptions = [
  { label: 'Payoff', value: eEscrowWireDisbursementCategories.payoff },
  { label: 'Due To Borrower', value: eEscrowWireDisbursementCategories.due_to_borrower },
  { label: 'Due To Seller', value: eEscrowWireDisbursementCategories.due_to_seller },
  { label: 'Third Party', value: eEscrowWireDisbursementCategories.third_party },
];
